// router
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/home";
import Hoc from "./hoc";
import About from "./pages/about";
import Practice from "./pages/practice";
import MainTeam from "./pages/team";
import InsightDetail from "./pages/insight";
import Articles from "./pages/articles";
import ArticleThree from "./components/articles/articleThree";
import ArticleTwo from "./components/articles/articleTwo";
import ArticleOne from "./components/articles/articleOne";

function App() {
  return (
    <div className="App">
      <Router>
        <Hoc>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/about" exact component={About} />
            <Route path="/services" exact component={Practice} />
            <Route path="/team" exact component={MainTeam} />
            <Route path="/insight/:name" exact component={InsightDetail} />
            <Route path="/articles" exact component={Articles} />
            <Route
              path="/articles/legal_requirements"
              exact
              component={ArticleOne}
            />
            <Route
              path="/articles/New_Sustainability_Bonds_Regulations_in_Tanzania"
              exact
              component={ArticleTwo}
            />
            <Route
              path="/articles/Compliance_with_Section_36_of_the_Consumer"
              exact
              component={ArticleThree}
            />
          </Switch>
        </Hoc>
      </Router>
    </div>
  );
}

export default App;
